import { render, staticRenderFns } from "./confirmVerify.vue?vue&type=template&id=dd626dd6&scoped=true&"
import script from "./confirmVerify.vue?vue&type=script&lang=js&"
export * from "./confirmVerify.vue?vue&type=script&lang=js&"
import style0 from "./confirmVerify.vue?vue&type=style&index=0&id=dd626dd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd626dd6",
  null
  
)

export default component.exports